<template>
  <el-date-picker
    :value="value"
    @input="onInput"
    :type="type"
    :placeholder="placeholder"
    :format="format"
    :picker-options="options"
    :default-time="defaultTime"
    :disabled="disabled"
    :clearable="clearable"
  >
  </el-date-picker>
</template>

<script>
import dayjs from 'dayjs'

export default {
  props: {
    type: String,
    value: [String, Date, Number],
    endTime: [String, Date, Number],
    startTime: [String, Date, Number],
    valueFormat: String,
    format: String,
    placeholder: String,
    defaultTime: String,
    disabled: Boolean,
    clearable: Boolean,
    intervalDays: Number, // 相隔天数
    minDate: [String, Date, Number],
    maxDate: [String, Date, Number]
  },
  data() {
    return {
      options: {
        disabledDate: this.disabledDate
      }
    }
  },
  methods: {
    onInput(value) {
      if (this.type == 'date' && value instanceof Date && this.defaultTime) {
        const [hour, minute, second] = this.defaultTime.split(':')
        value.setHours(Number(hour) || 0)
        value.setMinutes(Number(minute) || 0)
        value.setSeconds(Number(second) || 0)
      }
      this.$emit('input', value)
    },
    disabledDate(time) {
      const t = time.getTime() // Moved this outside for reuse
      // 添加 minDate 和 maxDate 的检查
      if (this.minDate) {
        const minDateTimestamp = this.parseDate(this.minDate)
        if (minDateTimestamp !== null && t < minDateTimestamp) {
          return true
        }
      }
      if (this.maxDate) {
        const maxDateTimestamp = this.parseDate(this.maxDate)
        if (maxDateTimestamp !== null && t > maxDateTimestamp) {
          return true
        }
      }
      let sT = this.startTime ? this.parseDate(this.startTime) : null
      let eT = this.endTime ? this.parseDate(this.endTime) : null
      // 处理 startTime
      if (sT !== null) {
        if (this.intervalDays) {
          return (
            t < sT || t > sT + (this.intervalDays - 1) * 1000 * 60 * 60 * 24
          )
        }
        return t < sT
      }
      // 处理 endTime
      if (eT !== null) {
        if (this.intervalDays) {
          return t > eT || t < eT - this.intervalDays * 1000 * 60 * 60 * 24
        }
        return t > eT
      }
      return false // 确保在没有条件满足时返回一个默认值
    },
    parseDate(date) {
      if (typeof date === 'number') return date
      if (date instanceof Date) return date.getTime()
      // 使用 dayjs 解析日期字符串
      const dayDate = dayjs(date)
      return dayDate.isValid() ? dayDate.valueOf() : null // 返回时间戳
    }
  }
}
</script>
